module.exports = __webpack_public_path__ + "media/images/logo-cf5cc801fceb1d579e7a1b700987c246.svg";